import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'

const URL_PATH_PREFIX = '/error/';

export class ErrorPage extends Component {

    state = {
        error: {
            caption: "Error",
            message: "An error occured.",
            code:"80000"
        }
    }

    componentDidMount() {
        this.retrieveUrlParams();
    }

    retrieveUrlParams = () => {
        const paths = this.props.location.pathname.split("/").filter(e => e !== null && e !== '');
        if (paths.length > 1) {
            this.setError(paths[1]);
        }
    }

    setError = (code) => {
        let error = { code: code };
        switch (code.toLowerCase()) {
            case "80000":
            case "80001":
            case "80002":
                error.caption = "Expired Link";
                error.message = "This link is no longer valid.";
                break;
            default:
                error.caption = "Error";
                error.message = "An error occured.";
                break;
        }
        
        this.setState({
            error: error
        });
    }

    render() {
        return (
            <div className="not-found">
                <h1>{this.state.error.caption} - Code {this.state.error.code}</h1>
                <h5>{this.state.error.message}</h5>
                <Link to='/'>
                    <button type="button">GO TO HOMEPAGE</button>
                </Link>
            </div>
        )
    }
}

export default withRouter(ErrorPage)

